import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  beforeReflex() {
    document.body.classList.add("stimulus-loading");
  }
  afterReflex() {
    document.body.classList.remove("stimulus-loading");
  }
  // Existing lifecycle (afterReflex, reflexError, reflexHalted, onReflexTimeout)
  // should call: document.body.classList.remove("stimulus-loading");
}
